import { render, staticRenderFns } from "./TokenDetail.vue?vue&type=template&id=0003dd30&"
import script from "./TokenDetail.vue?vue&type=script&lang=js&"
export * from "./TokenDetail.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports